// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kVC0","colMin":"styles_colMin__iVJCt"};